import React from "react";
import type { ReactNode } from "react";
import {
  CheckboxGroup as CheckboxGroupAria,
  Label as LabelAria,
  Text,
} from "react-aria-components";
import type { CheckboxGroupProps, ValidationResult } from "react-aria-components";

import { cn } from "@/lib/helpers/cn";

import { Heading2 } from "../atoms/Heading";
import { FieldError2 } from "../atoms/FieldError";

export type CheckboxGroup2Props = {
  children?: ReactNode;
  description?: string;
  errorMessage?: ((validation: ValidationResult) => string) | string;
  label?: string;
} & Omit<CheckboxGroupProps, "children">;

export function CheckboxGroup2({
  children,
  description,
  errorMessage,
  label,
  ...props
}: CheckboxGroup2Props) {
  return (
    <CheckboxGroupAria className="tw:flex tw:flex-col tw:gap-3" {...props}>
      <LabelAria>
        <Heading2 size={2}>{label}</Heading2>
      </LabelAria>

      <div
        className={cn(
          "tw:flex tw:flex-col tw:gap-2",
          "tw:[&>label]:mb-0! tw:[&>label]:flex! tw:[&>label]:items-baseline",
        )}
      >
        {children}
      </div>

      {description && (
        <Text className="tw:mb-5" slot="description">
          <small>{description}</small>
        </Text>
      )}

      <FieldError2>{errorMessage}</FieldError2>
    </CheckboxGroupAria>
  );
}
